import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import Player from "../Room/Player/index.jsx";
import PointBar from "../Room/PointBar/index.jsx";
import Board from "../Room/Board/index.jsx";
import HistoryRoomController from "../HistoryRoomController/HistoryRoomController.jsx";
import FinishHistoryRoom from "../Room/RoomModal/FinishHistoryRoom.jsx";

const HistoryRoom = function ({isActive}) {
    const {id: userId, currency, isMobile, avatar: avatarIndex, nickName} = useSelector(state => state.user);
    const {selectedRoomId: roomId, selectedRooms} = useSelector(state => state.history);
    const selectedRoomActions = selectedRooms?.[roomId];
    const [currentActionIndex, setActionIndex] = useState(0);
    const [currentRoundIndex, setRoundIndex] = useState(0);
    const [isAutoplayActive, setAutoplay] = useState(false);
    const timeoutRef = useRef(null);
    const room = selectedRoomActions?.[currentRoundIndex]?.[currentActionIndex];
    const currentRound = selectedRoomActions?.[currentRoundIndex];
    const isLastActionInRound = currentActionIndex === currentRound?.length - 1;
    const isLastRound = currentRoundIndex >= selectedRoomActions?.length - 1;
    const opponentId = room?.round?.opponentId;
    const players = room?.round?.players;
    let topPlayer = players?.[opponentId];
    let bottomPlayer = players?.[userId];
    if (userId === topPlayer?.platformId) {
        bottomPlayer = players?.[userId];
        topPlayer = players?.[room?.round?.playerId]
    }

    useEffect(() => {
        if (!isAutoplayActive) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
            return;
        }

        const tick = () => {
            const currentRound = selectedRoomActions?.[currentRoundIndex];
            const isLastActionInRound = currentActionIndex === currentRound?.length - 1;
            const isLastRound = currentRoundIndex >= selectedRoomActions?.length - 1;

            if (isLastActionInRound && isLastRound) {
                setAutoplay(false);
                return;
            }

            nextStep(false);

            timeoutRef.current = setTimeout(tick, 500);
        };

        timeoutRef.current = setTimeout(tick, 500);

        return () => clearTimeout(timeoutRef.current);
    }, [isAutoplayActive, currentActionIndex, currentRoundIndex]);


    const nextStep = (disableAutoplay = true) => {

        if (isAutoplayActive && disableAutoplay) autoplayToggle();

        if (!isLastActionInRound) {
            setActionIndex(prev => prev + 1);
            return;
        }

        if (!isLastRound) {
            setRoundIndex(prev => prev + 1);
            setActionIndex(0);
        }
    };

    const prevStep = () => {
        if (isAutoplayActive) autoplayToggle();

        if (currentRoundIndex === 0 && currentActionIndex === 0) return;

        if (currentActionIndex > 0) {
            setActionIndex(currentActionIndex - 1);
        } else {
            const prevRoundIndex = currentRoundIndex - 1;
            const prevRoundActionsLength = selectedRoomActions[prevRoundIndex]?.length || 0;

            setRoundIndex(prevRoundIndex);
            setActionIndex(prevRoundActionsLength - 1);
        }
    };


    const nextRound = () => {
        if (isAutoplayActive) autoplayToggle();

        if (isLastRound) return;

        setRoundIndex(prev => prev + 1);
        setActionIndex(0);
    }

    const prevRound = () => {
        if (isAutoplayActive) autoplayToggle();

        if (currentRoundIndex === 0) return;

        setRoundIndex(currentRoundIndex - 1);
        setActionIndex(0);
    }

    const autoplayToggle = () => {
        setAutoplay((prev) => !prev);
    };


    if (!room) return

    return (
        <div className={`game ${isActive ? 'active' : 'inActive'}`}>
            <div className="game__wrapper">
                <div className="room--wrapper">
                    {!isMobile && <div className="room__ratio"/>}
                    <div className={"board"}>
                        <div className="board__wrapper">
                            {!isMobile &&
                                <div className="board__view">
                                    <span className="board__view--wrapper"></span>
                                </div>
                            }
                            <div className="board__content board__content-view-room">
                                <Player
                                    playerData={topPlayer}
                                    playable={false}
                                    top={true}
                                    position={'top'}
                                    avatarIndex={topPlayer?.avatar || 1}
                                    nickName={topPlayer?.platformId}
                                    isViewRoom={room?.isViewRoom || room?.historyRoomPlayer}
                                    timers={{}}
                                />
                                {isLastActionInRound && isLastRound &&
                                    <FinishHistoryRoom
                                        points={room?.points?.global}
                                        winnerId={room.winnerId}
                                        userId={userId}
                                        opponentId={topPlayer?.platformId}
                                        winAmount={room.conventions.winAmountByCurrencies?.[currency]}
                                        loserId={room.loserId}
                                    />
                                }
                                <div className="board__center">
                                    <PointBar
                                        points={room?.points}
                                        topPlayerId={topPlayer?.platformId}
                                        bottomPlayerId={bottomPlayer?.platformId}
                                        roomId={room?.roomId}
                                        conventions={room?.conventions}
                                        isInGame={userId === bottomPlayer?.platformId}
                                        currency={currency}
                                        isTournament={room?.tournamentId}
                                    />
                                    <Board
                                        roomId={roomId}
                                        topCards={topPlayer?.cards || []}
                                        bottomCards={bottomPlayer?.cards || []}
                                        trump={room?.round?.trump}
                                        boardWinnerId={room?.round?.boardWinnerId}
                                        bottomPlayerId={bottomPlayer?.platformId}
                                        topPlayerId={topPlayer?.platformId}
                                        playedCards={room?.round?.playedCards}
                                        activePlayerId={room?.round?.activePlayerPlatformId}
                                        hiddenBitaCards={room?.round?.hiddenBitaCards}
                                        selectedCombinationCards={room?.selectedCombinationCards}
                                        cardsSelectable={false}
                                        isViewRoom={true}
                                        publishedCombinationCards={room?.round?.publishedCombinationCards}
                                        resetHand={currentActionIndex >= currentRound?.length - 1}
                                    />
                                </div>
                                <Player
                                    playable={false}
                                    playerData={bottomPlayer}
                                    top={false}
                                    historyRoomPlayer={room?.historyRoomPlayer}
                                    position={'bottom'}
                                    avatarIndex={avatarIndex || 1}
                                    nickName={userId}
                                    isViewRoom={room?.isViewRoom || room?.historyRoomPlayer}
                                    timers={{}}
                                >
                                    <HistoryRoomController
                                        nextStep={nextStep}
                                        nextRound={nextRound}
                                        prevRound={prevRound}
                                        prevStep={prevStep}
                                        autoplayToggle={autoplayToggle}
                                        isAutoplayActive={isAutoplayActive}
                                    />
                                </Player>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoryRoom;